import { useTypedParams } from '@sorare/routing';

import { LeaderboardPage } from '#src/components/collections/LeaderboardPage/index.tsx';

import type { PageParams } from './__generated__/routeParams.ts';

const MyClubSlugCollectionsLeaderboardPage = () => {
  const { collection, slug } = useTypedParams<PageParams>();
  return <LeaderboardPage collection={collection} slug={slug} />;
};

export default MyClubSlugCollectionsLeaderboardPage;
